import { render } from "./TheMenuSection.vue?vue&type=template&id=201f7742"
import script from "./TheMenuSection.vue?vue&type=script&lang=js"
export * from "./TheMenuSection.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__